module.exports = __webpack_public_path__ + "static/media/comment4_4.66fd93d4.png";